import { Icon } from '@shared/components/icons';

//* 관리자 홈(런처 그리드)과 AdminNavBar 사이드바가 공유하는 메뉴 정의.
//* 항목 추가/삭제는 여기 한 곳만 수정하면 두 화면에 함께 반영된다.

export type AdminMenuIconKey = keyof ReturnType<typeof Icon>;

export interface AdminMenuItem {
  label: string;
  to: string;
  icon: AdminMenuIconKey;
  //* 안 읽은 패치노트 점 표시 대상 (읽음 여부는 기기별 localStorage)
  releaseNoteDot?: boolean;
  //* DN 미연결(none) 장례식장 수 배지 표시 대상 (관리자 홈 런처에서만 렌더)
  dnNoneBadge?: boolean;
  //* 관리자 홈 런처에만 노출하고 사이드바에서는 숨기는 항목
  //* (사이드바에 이미 다른 진입점이 있어 줄만 늘어나는 경우)
  hideInSidebar?: boolean;
}

export interface AdminMenuGroup {
  label: string;
  items: AdminMenuItem[];
  //* 관리자 홈 런처에만 노출하고 사이드바에서는 숨기는 그룹 (관리자가 거의 쓰지 않는 업무)
  hideInSidebar?: boolean;
}

//* 사이드바는 중첩 경로에서도 열리므로 반드시 절대 경로로 적는다
export const adminMenuGroups: AdminMenuGroup[] = [
  {
    label: '조회 · 분석',
    items: [
      { label: '전화검색', to: '/admin/phone-search', icon: 'Phone' },
      { label: '답례 관리', to: '/admin/courtesy-manage', icon: 'Courtesy' },
      { label: '문의 관리', to: '/admin/enquiry', icon: 'CS' },
      { label: '데이터 분석', to: '/admin/analytics', icon: 'Calendar' },
    ],
  },
  {
    label: '부고 업무',
    //* 관리자는 부고 업무를 거의 하지 않으므로 사이드바에서는 제외 (부고 홈에서 접근)
    hideInSidebar: true,
    items: [
      { label: '부고 등록', to: '/fevent/add', icon: 'Register' },
      { label: '부고 관리', to: '/fevent/manage', icon: 'BugoMessage' },
      { label: '화환 보내기', to: '/flower-store', icon: 'Flower' },
    ],
  },
  {
    label: '공지사항',
    items: [
      { label: '공지 등록', to: '/bugo-brand/announcement/add', icon: 'Send' },
      { label: '공지 관리', to: '/bugo-brand/announcement/manage', icon: 'View' },
    ],
  },
  {
    label: '운영 관리',
    items: [
      {
        label: '장례식장',
        to: '/admin/funeral-home-info/manage',
        icon: 'LocationDotSolid',
        dnNoneBadge: true,
      },
      { label: '상조 관리', to: '/admin/bugo-brand', icon: 'OtherApps' },
      { label: 'DN 관리', to: '/admin/distribution-network', icon: 'Link' },
      { label: '계정 관리', to: '/admin/users', icon: 'User' },
      //* 답례품 스토어 메인 배너 (등록·기간·순서·상조별 노출)
      { label: '스토어 배너', to: '/admin/gift-store-banner', icon: 'UploadImage' },
      //* "로그인이 안 된다" 전화 응대 — 비밀번호 반복 실패로 잠긴 기기를 아이디로 찾아 해제
      { label: '로그인 잠금 해제', to: '/admin/login-device-lock', icon: 'Setting' },
      //* 애드콘 API 연동 대시보드(발행 현황·확인 필요, /admin 밖 경로). 발송 테스트(/gift-api/test)는 이 안의 버튼으로
      { label: '애드콘 API', to: '/gift-api', icon: 'Delivery' },
      //* 애드콘 계약 상품 카탈로그 — 상품 연결 때 계약번호 찾기
      { label: '애드콘 상품', to: '/gift-api/goods', icon: 'View' },
    ],
  },
  {
    label: '콘솔 이동',
    items: [
      { label: '화환 판매', to: '/flower-seller', icon: 'Wreath' },
      { label: '답례품 관리', to: '/gift-seller/home', icon: 'DP' },
      { label: '부고 홈', to: '/', icon: 'Home' },
    ],
  },
  {
    label: '기타',
    items: [
      {
        label: '업데이트 소식',
        to: '/admin/release-notes',
        icon: 'Question',
        releaseNoteDot: true,
      },
      {
        //* 사이드바에서는 상단 이름 블록이 같은 곳으로 가므로 홈 런처에만 둔다
        label: '계정정보',
        to: '/admin/settings',
        icon: 'User',
        hideInSidebar: true,
      },
    ],
  },
];
